import React, { FC } from 'react';

import { Radio } from 'antd';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { IRootReducers } from 'src/reducers';

interface OwnProps {
  donation: number;
  selected: boolean;
}

const mapStateToProps = (state: IRootReducers) => {
  return {
    userPoints: state.auth.userPoints,
  };
};

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

const ProductItem: FC<Props> = ({
  donation,
  selected,
  userPoints,
}): JSX.Element => {
  const notEnoughPoints = donation > userPoints;

  const cardClassName = classNames('checkout-card rounded-donation-card', {
    'rounded-donation-card--selected': selected,
  });

  const noPointsIconClassName = classNames(
    { 'icon item__icon--points item': !notEnoughPoints },
    { 'icon item__icon--points item item__icon-disabled': notEnoughPoints }
  );

  const noPointsTextClassName = classNames(
    {
      'item__wrapper--text': !notEnoughPoints,
    },
    { 'item__wrapper--text-disabled item__icon-disabled': notEnoughPoints }
  );

  return (
    <Radio.Button
      id={donation.toString()}
      disabled={notEnoughPoints}
      key={donation.toString()}
      value={donation}
      autoFocus={false}
      className="item__container"
    >
      <div className={cardClassName} key={donation}>
        <div className="item__wrapper">
          <div className={noPointsTextClassName}>{donation}</div>
          <div className={noPointsIconClassName}></div>
        </div>
      </div>
    </Radio.Button>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProductItem);
